import actions from "~/shared/actions";

const defaultState = {
	bundles: [],
	customer: {},
	started: false,
	selectedPkbs: [],
};

export default function flyttPkbReducer(state = defaultState, action) {
	switch (action.type) {
		case actions.START_FLYTT_PKB:
			return { ...state, started: true };
		case actions.SELECT_PKBS:
			return {
				...state,
				selectedPkbs: action.data.selectedPkbs,
				consolidate: action.data.consolidate,
			};
		case actions.CONFIRM_PKB:
			return {
				...state,
				customer: action.data,
			};
		case actions.CREATE_SIGNING_ORDER_REQUEST:
			return {
				...state,
				bundles: [...state.bundles.filter((b) => b.id !== action.data.id), { ...action.data }],
			};
		case actions.CREATE_SIGNING_ORDER_RESPONSE:
			return {
				...state,
				bundles: state.bundles.map((bundle) => {
					if (bundle.id !== action.data.bundleId) {
						return bundle;
					}
					return {
						...bundle,
						signingId: action.data.id,
						signingUrl: action.data.url,
					};
				}),
			};
		default:
			return state;
	}
}
